import React, { useState, useEffect, useRef } from "react";
import GeneratePDF from "./GeneratePDF";
import Pagination from "./Pagination";
import useOrdersData from "../hooks/useOrdersData";
import DrawingModal from "./DrawingModal";
import EditOrderModal from "./EditOrderModal";
import DeleteInvoiceModal from "./DeleteInvoiceModal";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useTheme } from "../context/ThemeContext";
// import DeleteOrderModal from "./DeleteOrderModal";
import SearchIcon from "@mui/icons-material/Search";
import API_BASE_URL from "../config";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ConfirmStatusModal from "./ConfirmStatusModal";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import Tooltip from "@mui/material/Tooltip";
import OrderItemsModal from "./OrderItemsModal";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { getAdvancePayments } from "../hooks/advancePaymentsApi";
import AdvancePaymentsModal from "./AdvancePaymentsModal";

const AllOrdersList = ({ users = [] }) => {
  const {
    orders,
    fetchAllOrders,
    deleteOrder,
    updateOrder,
    openDrawingModal,
    handleSaveDrawing,
    handleClearDrawing,
    uploadInvoice,
    downloadInvoice,
    deleteInvoice,
    toggleFinalizatStatus,
    uploadDrawing,
    downloadDrawing,
    deleteDrawing,
  } = useOrdersData();

  const storedPage = localStorage.getItem("currentPage");
  const [isDrawingModalOpen, setIsDrawingModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [drawingData, setDrawingData] = useState("");
  const signatureRef = useRef(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [orderToEdit, setOrderToEdit] = useState(null);
  const [pdfKey, setPdfKey] = useState(Date.now());
  const [successMessage, setSuccessMessage] = useState("");
  const fileInputRefs = useRef({});
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const [isDeleteInvoiceModalOpen, setIsDeleteInvoiceModalOpen] =
    useState(false);
  const [orderToDeleteInvoice, setOrderToDeleteInvoice] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(null);
  const { darkMode, toggleTheme } = useTheme(); // 🔥 toggleTheme-et is importáljuk!
  const [isDeleteOrderModalOpen, setIsDeleteOrderModalOpen] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    storedPage ? parseInt(storedPage, 10) : 1
  );
  const [selectedOrderForItems, setSelectedOrderForItems] = useState(null);
  const [isItemsModalOpen, setIsItemsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(""); // 🔥 Felhasználói szűrő
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [confirmStatusModalOpen, setConfirmStatusModalOpen] = useState(false);
  const [orderToToggle, setOrderToToggle] = useState(null);
  const [orderToDeleteDrawing, setOrderToDeleteDrawing] = useState(null);
  const [isDeleteDrawingModalOpen, setIsDeleteDrawingModalOpen] =
    useState(false);
  const [showStats, setShowStats] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [payments, setPayments] = useState({});
  const token = localStorage.getItem("token");
  const [isPaymentsModalOpen, setIsPaymentsModalOpen] = useState(false);
  const [selectedOrderForPayments, setSelectedOrderForPayments] = useState(null);
  const DEFAULT_YEAR = 2026;
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(DEFAULT_YEAR);
  const [selectedCompany, setSelectedCompany] = useState("All");

  const checkPassword = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/auth/verify-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || "Parolă incorectă!");

      if (data.message?.toLowerCase().includes("corect")) {
        setShowStats(true);
        setIsPasswordModalOpen(false);
        setPasswordError(null);
        fetchAllOrders(selectedYear, selectedCompany);
      } else {
        setPasswordError(data.message || "Parolă incorectă!");
      }
    } catch (error) {
      setPasswordError(error.message);
    }
  };

  useEffect(() => {
    if (!isPasswordModalOpen) {
      const searchInput = document.querySelector('input[placeholder="Căutare..."]');
      if (searchInput) {
        searchInput.value = "";
        searchInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
      setSearchTerm("");
    }
  }, [isPasswordModalOpen]);

  useEffect(() => {
    const fetchAdvancePayments = async () => {
      const paymentMap = {};
      for (const order of orders) {
        if (order.isAdvanceOrder) {
          try {
            const data = await getAdvancePayments(order.id, token);
            const total = data.payments.reduce((sum, p) => sum + p.amount, 0);
            paymentMap[order.id] = total;
          } catch (err) {
            console.error("Eroare la plăți avans:", err);
          }
        }
      }
      setPayments(paymentMap);
    };

    if (orders.length > 0) fetchAdvancePayments();
  }, [orders]);

  useEffect(() => {
    localStorage.setItem("currentPage", currentPage);
  }, [currentPage]);

  // Betöltjük az összes felhasználót (ha nem történt meg)
  // useEffect(() => {
  //   if (!ordersLoaded) {
  //     fetchAllOrders(selectedYear);
  //     setOrdersLoaded(true);
  //   }
  // }, [fetchAllOrders, ordersLoaded, selectedYear]);

  useEffect(() => {
    fetchAllOrders(selectedYear, selectedCompany);
  }, [fetchAllOrders, selectedYear, selectedCompany]);

  // Felhasználók listája a szűrőhöz
  const [allUsers, setAllUsers] = useState([]);

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };

  const formatPrice = (price) => {
    if (!price) return "0";
    return price.toLocaleString("ro-Ro");
  };

  const handleFileUpload = async (orderId, file) => {
    if (!file) return;
    try {
      setUploadSuccess(`📄 Se încarcă: ${file.name}...`);
      await uploadInvoice(orderId, file);
      setUploadSuccess("✅ Factura a fost încărcată!");
      fetchAllOrders(selectedYear, selectedCompany); // 🔄 Frissítés a feltöltés után

      // 🔥 Értesítés eltüntetése 2 másodperc múlva
      setTimeout(() => setUploadSuccess(null), 2000);
    } catch (error) {
      console.error("❌ Eroare la încărcarea facturii:", error);
      setUploadSuccess("❌ Eroare la încărcare!");
      setTimeout(() => setUploadSuccess(null), 2000);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${API_BASE_URL}/api/users`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error("Hiba a felhasználók lekérésekor.");
        }

        const data = await response.json();
        setAllUsers(data);
      } catch (err) {
        console.error("Hiba a felhasználók lekérésekor:", err);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredOrders = orders.filter((order) => {
    const searchText = searchTerm.toLowerCase();
    return (
      (!selectedUser || order.user?.id === parseInt(selectedUser)) &&
      (order.orderNumber.toString().includes(searchText) ||
        (order.customer?.name?.toLowerCase().includes(searchText) ?? false) ||
        (order.customer?.city?.toLowerCase().includes(searchText) ?? false) ||
        (order.invoiceFileName?.toLowerCase().includes(searchText) ?? false) ||
        (order.invoiceUrl?.toLowerCase().includes(searchText) ?? false))
    );
  });

  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (!sortConfig.key) return 0;

    let valA, valB;

    if (sortConfig.key === "customerName") {
      valA = a.customer?.name?.toLowerCase() || "";
      valB = b.customer?.name?.toLowerCase() || "";
    } else if (sortConfig.key === "agentName") {
      valA = a.user?.name?.toLowerCase() || "";
      valB = b.user?.name?.toLowerCase() || "";
    } else if (sortConfig.key === "orderNumber") {
      valA = parseFloat(a.orderNumber) || 0;
      valB = parseFloat(b.orderNumber) || 0;
      return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    } else if (sortConfig.key === "totalPrice") {
      valA = parseFloat(a.totalPrice) || 0;
      valB = parseFloat(b.totalPrice) || 0;
      return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    } else {
      valA = a[sortConfig.key]?.toString().toLowerCase() || "";
      valB = b[sortConfig.key]?.toString().toLowerCase() || "";
    }

    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const ordersPerPage = 12;
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = sortedOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleOpenDrawing = async (order) => {
    setSelectedOrder(order);
    const drawingData = await openDrawingModal(order);
    setDrawingData(drawingData);
    setIsDrawingModalOpen(true);
  };

  const handleEditOrder = (order) => {
    setOrderToEdit(order); // 🔥 Javítva!
    setIsEditModalOpen(true);
  };

  const handleSaveDrawingLocal = async () => {
    if (!selectedOrder) return;

    const success = await handleSaveDrawing(selectedOrder, signatureRef);

    if (success) {
      setSuccessMessage("✅ A rajz sikeresen mentve lett!");
      setTimeout(() => setSuccessMessage(""), 3000);
      setIsDrawingModalOpen(false);
      setPdfKey(Date.now()); // 🔥 PDF frissítése
      fetchAllOrders(selectedYear, selectedCompany); // 🔄 Frissítsük az összes rendelést
    }
  };

  const handleClearDrawingLocal = async () => {
    if (!selectedOrder) return;

    const success = await handleClearDrawing(selectedOrder, signatureRef);

    if (success) {
      setSuccessMessage("✅ A rajz sikeresen törölve lett!");
      setTimeout(() => setSuccessMessage(""), 3000);
      setDrawingData("N/A");
      setPdfKey(Date.now()); // 🔥 PDF frissítése
      fetchAllOrders(selectedYear, selectedCompany); // 🔄 Frissítsük az összes rendelést
    }
  };

  const handleDeleteInvoice = async () => {
    if (!orderToDeleteInvoice) return;

    try {
      await deleteInvoice(orderToDeleteInvoice.id);
      fetchAllOrders(selectedYear, selectedCompany); // 🔄 Frissítés törlés után
      setDeleteSuccess("✅ Factura a fost ștearsă cu succes!"); // ✅ Siker popup

      // 🔥 2 másodperc múlva eltüntetjük a popupot
      setTimeout(() => setDeleteSuccess(null), 2000);
    } catch (error) {
      console.error("❌ Eroare la ștergerea facturii:", error);
    } finally {
      setIsDeleteInvoiceModalOpen(false);
      setOrderToDeleteInvoice(null);
    }
  };

  const handleDrawingUpload = async (orderId, file) => {
    if (!file || file.type !== "application/pdf") {
      setUploadSuccess("❌ Doar fișiere PDF sunt acceptate!");
      setTimeout(() => setUploadSuccess(null), 2000);
      return;
    }

    try {
      await uploadDrawing(orderId, file);
      setUploadSuccess("✅ Schița a fost încărcată!");
      fetchAllOrders(selectedYear, selectedCompany);
    } catch (err) {
      setUploadSuccess("❌ Eroare la încărcare!");
      console.error(err);
    } finally {
      setTimeout(() => setUploadSuccess(null), 2000);
    }
  };

  const handleDeleteDrawing = async () => {
    if (!orderToDeleteDrawing) return;
    try {
      await deleteDrawing(orderToDeleteDrawing.id);
      fetchAllOrders(selectedYear, selectedCompany);
      setDeleteSuccess("✅ Schița a fost ștearsă cu succes!");
    } catch (err) {
      console.error(err);
    } finally {
      setOrderToDeleteDrawing(null);
      setIsDeleteDrawingModalOpen(false);
      setTimeout(() => setDeleteSuccess(null), 2000);
    }
  };

  return (
    <div
      className={`min-h-screen p-2 py-6 ${darkMode ? "bg-gray-900" : "bg-gray-200"
        }`}
    >
      {" "}
      {/* ✅ Sikeres törlés popup */}
      {deleteSuccess && (
        <div className="fixed z-50 top-20 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-opacity duration-500">
          {deleteSuccess}
        </div>
      )}
      {/* 🔥 FELUGRÓ ÜZENET KÖZÉPEN MEGJELENÍTVE */}
      {uploadSuccess && (
        <div className="fixed z-50 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-opacity duration-500">
          {uploadSuccess}
        </div>
      )}
      <div className="flex justify-between items-center mb-4">
        <h2
          className={`text-2xl font-semibold ${darkMode ? "text-white" : "text-black"
            }`}
        >
          Toate comenzile
        </h2>
        <div className="flex gap-6">
          {/* 🔍 Keresőmező Material-UI ikonnal */}
          <div className="relative flex items-center">
            <SearchIcon
              className={`absolute left-3 ${darkMode ? "text-gray-300" : "text-gray-500"
                }`}
            />
            <input
              type="text"
              placeholder="Căutare..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`pl-10 pr-4 py-2 border rounded-3xl shadow-sm w-96 transition-all ${darkMode
                ? "bg-gray-800 text-white border-gray-600 placeholder-gray-400"
                : "bg-white text-gray-900 border-gray-300 placeholder-gray-500"
                }`}
            />
          </div>

          <select
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.target.value)}
            className={`px-4 py-2 rounded-3xl border transition ${darkMode
                ? "bg-gray-800 text-white border-gray-600"
                : "bg-white text-black border-gray-300"
              }`}
          >
            <option value="All">Toate firmele</option>
            <option value="Marmorex">Marmorex</option>
            <option value="GranitOnline">Granit Online</option>
          </select>

          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className={`px-4 py-2 rounded-3xl border transition ${darkMode
              ? "bg-gray-800 text-white border-gray-600"
              : "bg-white text-black border-gray-300"
              }`}
          >
            {[currentYear, currentYear - 1].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>

          {/* 🔽 Felhasználói szűrő megmarad */}
          <select
            className={`${darkMode
              ? "bg-gray-800 text-white border-gray-600"
              : "bg-gray-200 text-black border-gray-400"
              } p-2 border rounded-3xl`}
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
          >
            <option value="">Toți agenții</option>
            {allUsers.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name} ({user.email})
              </option>
            ))}
          </select>
          <button
            onClick={() => setIsPasswordModalOpen(true)}
            className="px-4 py-2 rounded-3xl border-2 transition font-bold"
            style={{
              borderColor: darkMode ? "#66bb6a" : "#2e7d32",
              color: darkMode ? "#66bb6a" : "#fff",
              backgroundColor: darkMode ? "transparent" : "#2e7d32",
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = darkMode ? "#81c784" : "#1b5e20";
              e.target.style.backgroundColor = darkMode
                ? "rgba(102, 187, 106, 0.1)"
                : "rgba(46, 125, 50, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = darkMode ? "#66bb6a" : "#2e7d32";
              e.target.style.backgroundColor = darkMode
                ? "transparent"
                : "#2e7d32";
            }}
          >
            🔐 Statistici
          </button>

        </div>
      </div>
      <div className="flex flex-col justify-between min-h-[650px]">
        <div className="overflow-x-auto flex-grow">
          <table
            className={`w-full border text-sm leading-tight ${darkMode
              ? "border-gray-700 bg-gray-900 text-gray-300"
              : "border-gray-400 bg-white text-gray-800 shadow-lg"
              }`}
          >
            {" "}
            <thead>
              <tr
                className={`${darkMode
                  ? "bg-gray-700 text-white"
                  : "bg-gray-300 text-gray-900"
                  }`}
              >
                {" "}
                <th
                  className="border text-sm p-2 min-w-[120px] max-w-[120px] text-center cursor-pointer"
                  onClick={() => handleSort("orderNumber")}
                >
                  <div className="flex items-center justify-center gap-1">
                    <span>Nr. Comanda</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "orderNumber" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "orderNumber" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "orderNumber" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "orderNumber" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  className="border text-sm p-2 min-w-[100px] max-w-[100px] text-center cursor-pointer"
                  onClick={() => handleSort("customerName")}
                >
                  <div className="flex items-center justify-center gap-1">
                    <span>Client</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "customerName" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "customerName" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "customerName" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "customerName" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  className="border text-sm p-2 min-w-[110px] max-w-[110px] text-center truncate"
                  onClick={() => handleSort("agentName")}
                >
                  <div className="flex items-center justify-center gap-1">
                    <span>Agent</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "agentName" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "agentName" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "agentName" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "agentName" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                <th
                  className="border text-sm p-2 text-center"
                  onClick={() => handleSort("totalPrice")}
                >
                  <div className="flex items-center justify-center gap-1">
                    <span>Suma</span>
                    <div className="flex flex-col items-center leading-none gap-[2px]">
                      <div className="flex items-center gap-1">
                        <ArrowUpwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "totalPrice" &&
                              sortConfig.direction === "asc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "totalPrice" &&
                            sortConfig.direction === "asc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          A
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        <ArrowDownwardIcon
                          fontSize="small"
                          className={
                            sortConfig.key === "totalPrice" &&
                              sortConfig.direction === "desc"
                              ? ""
                              : "opacity-30"
                          }
                        />
                        <span
                          className={`text-xs ${sortConfig.key === "totalPrice" &&
                            sortConfig.direction === "desc"
                            ? ""
                            : "opacity-30"
                            }`}
                        >
                          Z
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
                {showStats && (
                  <>
                    <th className="border text-sm p-2 w-[90px] text-center">Cost achiziție</th>
                    <th className="border text-sm p-2 w-[90px] text-center">Profit net</th>
                    <th className="border text-sm p-2 w-[90px] text-center">% Marjă</th>
                  </>
                )}
                <th className="border text-sm p-2 w-[100px] text-center">
                  Plată avans
                </th>

                {/* <th className="border p-2">Oraș</th> */}
                <th className="border text-sm p-2 min-w-[100px] max-w-[100px] text-center">Dată</th>
                <th className="border text-sm p-2 w-[110px] text-center">Sursă</th>
                <th className="border text-sm p-2 min-w-[212px] max-w-[212px] text-center">Factură</th>
                <th className="border text-sm p-2 w-[120px] text-center">PDF</th>
                <th className="border text-sm p-2 w-[220px] text-center">Schiță</th>
                <th className="border text-sm p-2 w-[100px] text-center">
                  Status
                </th>
                <th className="border text-sm p-2 w-[140px] text-center">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order, index) => (
                  <tr
                    key={order.id}
                    className={`border transition text-center ${darkMode
                      ? index % 2 === 0
                        ? "bg-gray-800 hover:bg-gray-700"
                        : "bg-gray-900 hover:bg-gray-700"
                      : index % 2 === 0
                        ? "bg-gray-100 hover:bg-gray-200"
                        : "bg-white hover:bg-gray-200"
                      }`}
                  >
                    <td
                      className={`border p-2 min-w-[120px] max-w-[120px] text-center font-semibold cursor-pointer hover:underline ${darkMode
                        ? "text-white hover:text-gray-300"
                        : "text-black hover:text-gray-700"
                        }`}
                      onClick={() => {
                        setSelectedOrderForItems(order);
                        setIsItemsModalOpen(true);
                      }}
                    >
                      {order.orderNumber}
                    </td>
                    <td className="border min-w-[160px] max-w-[160px] truncate px-4 py-2">
                      <Tooltip title={order.customer?.name}>
                        <span className="block text-ellipsis whitespace-nowrap overflow-hidden">
                          {order.customer?.name}
                        </span>
                      </Tooltip>
                    </td>
                    {" "}
                    <td className="border text-sm p-2 min-w-[110px] max-w-[110px] text-center truncate">
                      {order.user?.name || "N/A"}
                    </td>{" "}
                    <td className="border text-sm p-2 w-[100px] text-center">
                      {formatPrice(order.totalPrice)} €
                    </td>

                    {showStats && (
                      <>
                        <td className={`border p-2 w-[90px] text-center ${order.totalCost > order.totalPrice ? "text-red-500 font-bold" : ""}`}>
                          {formatPrice(order.totalCost)} €
                        </td>
                        <td className={`border p-2 w-[120px] text-center ${order.grossProfit >= 0 ? "text-green-500 font-semibold" : "text-red-500 font-semibold"}`}>
                          {formatPrice(order.grossProfit)} €
                        </td>
                        <td className={`border p-2 w-[90px] text-center ${order.profitMargin >= 20 ? "text-green-500 font-semibold" : order.profitMargin > 0 ? "text-yellow-500 font-semibold" : "text-red-500 font-semibold"}`}>
                          {order.profitMargin.toFixed(2)}%
                        </td>
                      </>
                    )}
                    <td className="border text-sm p-2 w-[100px] text-center">
                      {order.isAdvanceOrder ? (
                        <div
                          className="flex flex-col items-center cursor-pointer hover:opacity-80"
                          title="Vizualizează plățile de avans"
                          onClick={() => {
                            setSelectedOrderForPayments(order);
                            setIsPaymentsModalOpen(true);
                          }}
                        >
                          <span
                            className={`text-xs font-semibold ${darkMode ? "text-gray-100" : "text-gray-800"
                              }`}
                          >
                            {order.advanceCompletionPercent
                              ? `${order.advanceCompletionPercent.toFixed(0)}%`
                              : "0%"}
                          </span>

                          <div
                            className={`w-16 rounded-full h-2 mt-1 ${darkMode ? "bg-gray-500" : "bg-gray-300"
                              }`}
                          >
                            <div
                              className={`h-2 rounded-full transition-all duration-300 ${darkMode ? "bg-green-500" : "bg-green-500"
                                }`}
                              style={{
                                width: `${Math.min(order.advanceCompletionPercent || 0, 100)}%`,
                              }}
                            ></div>
                          </div>

                        </div>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>


                    {/* ✅ Csak a számla neve, .pdf nélkül */}
                    <td className="border p-2 min-w-[100px] max-w-[100px] text-center">
                      {order.createdAt
                        ? new Date(order.createdAt).toLocaleDateString("ro-RO")
                        : "-"}
                    </td>

                    <td className="border p-2 w-[110px] text-center">
                      {(() => {
                        const src = order.customerSource ?? 0;
                        const colors = [
                          "bg-gray-100 text-gray-600",
                          "bg-blue-100 text-blue-800",
                          "bg-purple-100 text-purple-800",
                          "bg-green-100 text-green-800"
                        ];
                        const labels = ["Neclasificat", "Online", "Recomandare", "Recurent"];
                        return (
                          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${colors[src] || colors[0]}`}>
                            {labels[src] || "Online"}
                          </span>
                        );
                      })()}
                    </td>

                    {/* ✅ Külön oszlop a letöltés/törlés/feltöltéshez */}
                    <td className="border text-sm p-2 text-center min-w-[212px] max-w-[212px]">
                      {order.invoiceUrl ? (
                        <div className="flex items-center gap-2 justify-center">
                          <Button
                            variant="outlined"
                            startIcon={<DownloadIcon />}
                            sx={(theme) => ({
                              borderColor: darkMode ? "#66bb6a" : "#36993a",
                              color: darkMode ? "#66bb6a" : "#36993a",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              "&:hover": {
                                borderColor: darkMode ? "#66bb6a" : "#2d7d32",
                                backgroundColor: darkMode
                                  ? "rgba(102, 187, 106, 0.1)"
                                  : "rgba(54, 153, 58, 0.1)",
                              },
                            })}
                            onClick={() => downloadInvoice(order.invoiceUrl)}
                          >
                            Descarcă
                          </Button>

                          <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            sx={{
                              borderColor: "#f44336",
                              color: "#f44336",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              "&:hover": {
                                borderColor: "#f44336",
                                backgroundColor: "rgba(244, 67, 54, 0.1)",
                              },
                            }}
                            onClick={() => {
                              setOrderToDeleteInvoice(order);
                              setIsDeleteInvoiceModalOpen(true);
                            }}
                          >
                            Ștergere
                          </Button>
                        </div>
                      ) : (
                        <div className="relative flex items-center justify-center">
                          <input
                            type="file"
                            ref={(el) => (fileInputRefs.current[order.id] = el)}
                            accept="application/pdf"
                            className="hidden"
                            onChange={(e) => {
                              if (e.target.files.length > 0) {
                                handleFileUpload(order.id, e.target.files[0]);
                              }
                            }}
                          />
                          <Button
                            variant="outlined"
                            startIcon={<UploadFileIcon />}
                            sx={(theme) => ({
                              borderColor: darkMode ? "#90caf9" : "#0056B3",
                              color: darkMode ? "#90caf9" : "#0056B3",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              "&:hover": {
                                borderColor: darkMode ? "#90caf9" : "#003B80",
                                backgroundColor: darkMode
                                  ? "rgba(144, 202, 249, 0.1)"
                                  : "rgba(0, 86, 179, 0.15)",
                              },
                            })}
                            onClick={() =>
                              fileInputRefs.current[order.id]?.click()
                            }
                          >
                            Încarcă
                          </Button>
                        </div>
                      )}
                    </td>
                    <td className="border text-sm p-2 text-center w-[120px]">
                      <GeneratePDF
                        key={pdfKey}
                        orderData={order}
                        customerData={order.customer}
                      />
                    </td>
                    <td className="border text-sm p-2 text-center w-[140px]">
                      {order.drawingUrl ? (
                        <div className="flex items-center gap-2 justify-center">
                          <Button
                            variant="outlined"
                            startIcon={<DownloadIcon />}
                            sx={{
                              borderColor: darkMode ? "#66bb6a" : "#36993a",
                              color: darkMode ? "#66bb6a" : "#36993a",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              "&:hover": {
                                borderColor: darkMode ? "#66bb6a" : "#2d7d32",
                                backgroundColor: darkMode
                                  ? "rgba(102, 187, 106, 0.1)"
                                  : "rgba(54, 153, 58, 0.1)",
                              },
                            }}
                            onClick={() => downloadDrawing(order.drawingUrl)} // 👈 ezt implementálni kell
                          >
                            Descarcă
                          </Button>

                          <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            sx={{
                              borderColor: "#f44336",
                              color: "#f44336",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              "&:hover": {
                                borderColor: "#f44336",
                                backgroundColor: "rgba(244, 67, 54, 0.1)",
                              },
                            }}
                            onClick={() => {
                              setOrderToDeleteDrawing(order);
                              setIsDeleteDrawingModalOpen(true);
                            }}
                          >
                            Ștergere
                          </Button>
                        </div>
                      ) : (
                        <div className="relative flex items-center justify-center">
                          <input
                            type="file"
                            ref={(el) =>
                            (fileInputRefs.current[`drawing-${order.id}`] =
                              el)
                            }
                            accept="application/pdf"
                            className="hidden"
                            onChange={(e) => {
                              if (e.target.files.length > 0) {
                                handleDrawingUpload(
                                  order.id,
                                  e.target.files[0]
                                );
                              }
                            }}
                          />
                          <Button
                            variant="outlined"
                            startIcon={<UploadFileIcon />}
                            sx={{
                              borderColor: darkMode ? "#90caf9" : "#0056B3",
                              color: darkMode ? "#90caf9" : "#0056B3",
                              fontSize: "0.75rem",
                              textTransform: "none",
                              padding: "2px 8px",
                              minWidth: "fit-content",
                              "&:hover": {
                                borderColor: darkMode ? "#90caf9" : "#003B80",
                                backgroundColor: darkMode
                                  ? "rgba(144, 202, 249, 0.1)"
                                  : "rgba(0, 86, 179, 0.15)",
                              },
                            }}
                            onClick={() =>
                              fileInputRefs.current[
                                `drawing-${order.id}`
                              ]?.click()
                            }
                          >
                            Încarcă
                          </Button>
                        </div>
                      )}
                    </td>
                    <td className="border text-sm p-2 text-center w-[100px]">
                      <Button
                        variant="outlined"
                        sx={{
                          borderColor: order.finalizat ? "#4caf50" : "#ffa726",
                          color: order.finalizat ? "#4caf50" : "#ffa726",
                          fontSize: "0.75rem",
                          textTransform: "none",
                          padding: "2px 8px",
                          minWidth: "fit-content",
                          fontWeight: "bold",
                          minWidth: "80px", // 👈 Fix szélesség beállítása
                          maxWidth: "80px", // 👈 Fix szélesség beállítása
                          "&:hover": {
                            borderColor: order.finalizat ? "#66bb6a" : "#fb8c00",
                            backgroundColor: order.finalizat
                              ? "rgba(76, 175, 80, 0.1)"
                              : "rgba(255, 167, 38, 0.1)",
                          },
                        }}
                        onClick={() => {
                          setOrderToToggle(order);
                          setConfirmStatusModalOpen(true);
                        }}
                      >
                        {order.finalizat ? "Finalizat" : "Neexecutat"}
                      </Button>
                    </td>
                    <td className="border text-sm p-2 text-center w-[140px]">
                      <div className="flex justify-center gap-2">
                        <Button
                          variant="outlined"
                          startIcon={<EditIcon />}
                          sx={{
                            maxWidth: "110px",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            padding: "2px 8px",
                            minWidth: "fit-content",
                            borderColor: darkMode ? "#90caf9" : "#0056B3",
                            color: darkMode ? "#90caf9" : "#0056B3",
                            "&:hover": {
                              borderColor: darkMode ? "#90caf9" : "#003B80",
                              backgroundColor: darkMode
                                ? "rgba(144, 202, 249, 0.1)"
                                : "rgba(0, 86, 179, 0.15)",
                            },
                          }}
                          onClick={() => handleEditOrder(order)}
                        >
                          Editare
                        </Button>

                        <Button
                          variant="outlined"
                          startIcon={<DeleteIcon />}
                          sx={{
                            maxWidth: "110px",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            padding: "2px 8px",
                            minWidth: "fit-content",
                            borderColor: "#f44336",
                            color: "#f44336",
                            "&:hover": {
                              borderColor: "#f44336",
                              backgroundColor: "rgba(244, 67, 54, 0.1)",
                            },
                          }}
                          onClick={() => {
                            setOrderToDelete(order);
                            setIsDeleteOrderModalOpen(true);
                          }}
                        >
                          Ștergere
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center p-4 text-gray-400">
                    Nu există comenzi.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
      <EditOrderModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        order={orderToEdit}
        updateOrder={(data) => updateOrder(data, true, selectedYear, selectedCompany)}
      />
      <DrawingModal
        selectedOrder={selectedOrder}
        drawingData={drawingData}
        signatureRef={signatureRef}
        handleSaveDrawing={handleSaveDrawingLocal}
        handleClearDrawing={handleClearDrawingLocal}
        isModalOpen={isDrawingModalOpen}
        closeModal={() => setIsDrawingModalOpen(false)}
      />
      {/* <DeleteOrderModal
        isOpen={isDeleteOrderModalOpen}
        onClose={() => setIsDeleteOrderModalOpen(false)}
        onConfirm={(id) => {
          deleteOrder(id, true); // 🔥 Meghívja a törlési függvényt
          setIsDeleteOrderModalOpen(false); // ✅ Modál bezárása
        }}
        order={orderToDelete}
      /> */}
      <DeleteInvoiceModal
        isOpen={isDeleteInvoiceModalOpen}
        onClose={() => setIsDeleteInvoiceModalOpen(false)}
        onConfirm={handleDeleteInvoice}
        order={orderToDeleteInvoice}
      />
      <ConfirmStatusModal
        open={confirmStatusModalOpen}
        onClose={() => {
          setOrderToToggle(null);
          setConfirmStatusModalOpen(false);
        }}
        onConfirm={async () => {
          if (orderToToggle) {
            await toggleFinalizatStatus(orderToToggle.id, true, selectedYear); // `true` az admin nézet miatt
            setConfirmStatusModalOpen(false);
            setOrderToToggle(null);
          }
        }}
        isFinalizat={orderToToggle?.finalizat}
      />
      <ConfirmDeleteModal
        isOpen={isDeleteDrawingModalOpen}
        onClose={() => setIsDeleteDrawingModalOpen(false)}
        onConfirm={handleDeleteDrawing}
        entityName="schiță"
        title="Sigur doriți să ștergeți schița?"
        message={`Schița asociată comenzii ${orderToDeleteDrawing?.orderNumber} va fi ștearsă definitiv.`}
      />
      <ConfirmDeleteModal
        isOpen={isDeleteOrderModalOpen}
        onClose={() => setIsDeleteOrderModalOpen(false)}
        onConfirm={async () => {
          if (orderToDelete) {
            await deleteOrder(orderToDelete.id, true, selectedYear); //⬅️ `true`, mert admin nézet
            setDeleteSuccess("✅ Comanda a fost ștearsă cu succes!");
            setTimeout(() => setDeleteSuccess(null), 2000);
            setCurrentPage(1);
            setIsDeleteOrderModalOpen(false);
            setOrderToDelete(null);
          }
        }}
        entityName="comandă"
        title="Sigur doriți să ștergeți această comandă?"
        message={`Comanda cu numărul ${orderToDelete?.orderNumber} va fi ștearsă definitiv.`}
      /><AdvancePaymentsModal
        order={selectedOrderForPayments}
        open={isPaymentsModalOpen}
        onClose={() => {
          setIsPaymentsModalOpen(false);
          setSelectedOrderForPayments(null);
        }}
      />

      <OrderItemsModal
        open={isItemsModalOpen}
        onClose={() => setIsItemsModalOpen(false)}
        order={selectedOrderForItems}
      />
      <Dialog
        open={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: "16px", width: 400 },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Introduceți parola pentru a vizualiza statisticile
        </DialogTitle>
        <DialogContent sx={{ padding: 3 }}>
          <TextField
            type="password"
            label="Parola"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!passwordError}
            helperText={passwordError || ""}
            sx={{ mt: 2, borderRadius: "8px" }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
          <Button
            onClick={() => setIsPasswordModalOpen(false)}
            color="secondary"
            sx={{ borderRadius: "20px", paddingX: 3 }}
          >
            Anulare
          </Button>
          <Button
            onClick={checkPassword}
            variant="contained"
            color="primary"
            sx={{ borderRadius: "20px", paddingX: 3 }}
          >
            Verificare
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default AllOrdersList;
